import FlexBox from '@/atomic-components/FlexBox';
import CancellationAndReturnsIcon from '../../../../assets/pdp/cancellationIcon.svg';
import CareInstructionIcon from '../../../../assets/pdp/careInstructions.svg';
import QualityPerformanceIcon from '../../../../assets/pdp/qualityIcon.svg';
import WarrantyIcon from '../../../../assets/pdp/warrantyIcon.svg';
import FaqIcon from '../../../../assets/pdp/faqIcon.svg';
import ImportantTermsIcon from '../../../../assets/pdp/importantTerms.svg';
import ArrowWithCircle from '../../../../assets/pdp/arrowWithCircle.svg';
import { Box, Grid } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { getStyle } from '@/utils/theme/fonts';
import { getColor } from '@/utils/theme/colors';
import { LencoImage } from '@/atomic-components/Image';
import InclusionProductDataTabComponent, {
	StorytellingData,
} from './inclusionProductTabData';
import { useState } from 'react';
import SpecificationTab from './specificationTab';
import ExtraFeaturesComponent from '../../extraFeatures';
import ProductDesignFeatureGalleryComponent from './productDesignGallery';
import { Inclusion } from '@/services/catalogue/models/pdp';

type SpecificationsAndInclusionsProps = {
	inclusions: Inclusion[];
	storytelling?: StorytellingData;
	productType: string;
	faq: any;
	awards: string[];
};

type SpecificationsAndInclusionsIconProps = {
	cancellationAndReturns: any;
	careInstructions: any;
	qualityPerformance: any;
	warranty: any;
	faq: any;
	ImportantTerms: any;
};

type TabPanelProps = {
	children?: React.ReactNode;
	index: number;
	value: number;
};

const SpecificationsAndInclusionsIconMApper: SpecificationsAndInclusionsIconProps =
	{
		cancellationAndReturns: <CancellationAndReturnsIcon />,
		careInstructions: <CareInstructionIcon />,
		qualityPerformance: <QualityPerformanceIcon />,
		warranty: <WarrantyIcon />,
		faq: <FaqIcon />,
		ImportantTerms: <ImportantTermsIcon />,
	};

const PdpSpecificationsAndInclusions = (
	props: SpecificationsAndInclusionsProps
) => {
	const [openDrawerToSeeAllProducts, setOpenDrawerToSeeAllProducts] =
		useState(false);
	const [openProductGallery, setOpenProductGallery] = useState(false);
	const [galleryIndex, setGalleryIndex] = useState(0);

	const { inclusions } = props;

	const handleProductGallery = (index: number) => {
		setOpenProductGallery(true);
		setGalleryIndex(index);
	};

	return (
		<Grid item sx={{ width: '90%' }}>
			{props.productType != 'ITEM' && (
				<Box>
					<LencoTypography
						sx={{
							...getStyle('H9_Medium'),
							color: getColor('Gray 0'),
							paddingBottom: '24px',
						}}
					>
						Package Includes:
					</LencoTypography>
					<Box sx={{ paddingBottom: '60px' }}>
						{inclusions.map((inclusion: Inclusion) => {
							// const { url, aspectRatio } = inclusion?.thumbnail;
							return (
								<FlexBox
									key={inclusion.id}
									sx={{
										borderRadius: '8px',
										padding: '24px',
										background: '#FFFFFF',
										boxShadow: '0px 0px 16px rgba(34, 34, 34, 0.1)',
										alignItems: 'center',
										marginBottom: '16px',
									}}
								>
									<FlexBox>
										<Box
											key={inclusion?.label}
											sx={{ width: '153px', height: '153px' }}
										>
											<LencoImage url={inclusion?.thumbnail?.url} aspectRatio={inclusion?.thumbnail?.aspectRatio} />
										</Box>
									</FlexBox>

									<FlexBox direction='column' sx={{ padding: '8px' }}>
										<LencoTypography
											sx={{
												...getStyle('H11_Medium'),
												color: getColor('Gray 0'),
												paddingBottom: '8px',
											}}
										>
											{inclusion.title}
										</LencoTypography>
										{inclusion.quantity && (
											<LencoTypography
												sx={{
													...getStyle('Small_Medium'),
													color: getColor('Gray -1'),
													paddingBottom: '8px',
												}}
											>
												Quantity:{' '}
												<LencoTypography
													component='span'
													sx={{
														...getStyle('Small_SemiBold'),
														color: '#777777',
													}}
												>
													{inclusion.quantity}
												</LencoTypography>
											</LencoTypography>
										)}
										<LencoTypography
											sx={{
												...getStyle('P_Regular'),
												color: getColor('Gray -2'),
											}}
											componentUsage='PARAGRAPH'
										>
											{inclusion.description}
										</LencoTypography>
										<FlexBox
											sx={{
												paddingTop: '16px',
												alignItems: 'center',
												cursor: 'pointer',
											}}
											onClick={() => {
												setOpenDrawerToSeeAllProducts(true);
											}}
										>
											<LencoTypography
												sx={{
													...getStyle('P_Medium'),
													color: getColor('Minty 0'),

													textDecoration: 'underline',
													paddingRight: '8px',
												}}
											>
												Product Details{' '}
											</LencoTypography>
											<Box component='span'>
												<ArrowWithCircle />
											</Box>
										</FlexBox>
									</FlexBox>

									<InclusionProductDataTabComponent
										inclusions={props.inclusions}
										storyTelling={props?.storytelling}
										openDrawerToSeeAllProducts={openDrawerToSeeAllProducts}
										setOpenDrawerToSeeAllProducts={() =>
											setOpenDrawerToSeeAllProducts(false)
										}
										lineOfProduct={props?.productType}
										faq={props?.faq}
										awards={props?.awards}
									/>
								</FlexBox>
							);
						})}
					</Box>
				</Box>
			)}

			<Box>
				<SpecificationTab
					inclusions={props.inclusions}
					productType={props.productType}
				/>
			</Box>

			{props.productType == 'ITEM' && (
				<ExtraFeaturesComponent
					inclusion={props.inclusions[0]}
					faq={props.faq}
				/>
			)}
			<Grid item md={12}>
				<FlexBox sx={{ width: '100%' }}>
					{/* {props.storytelling && (
					<Box sx={{ width: '700px', paddingRight: '70px' }}>
						<StorytellingDataComponent storytelling={props?.storytelling} />
					</Box>
				)} */}
				</FlexBox>
			</Grid>

			<ProductDesignFeatureGalleryComponent
				designFeatures={props.inclusions[0].designFeatures[galleryIndex]}
				setOpenProductGallery={() => setOpenProductGallery(false)}
				openProductGallery={openProductGallery}
			/>

			{/* </FlexBox> */}
		</Grid>
	);
};

export default PdpSpecificationsAndInclusions;
